import React, { Component } from 'react';
import 'normalize.css';
import './styles.css';
			   
const ajaxurl = '/wp-json/feed-rss/v1/feeds';																																		  

const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };


const Card = (props) => {
    debugger;
    let img;
    let innerHeight;
    const src = props.card.feed.img_attr ? props.card.feed.img_attr.url : props.card.innerImg;
    const alt = props.card.feed.img_attr ? props.card.feed.img_attr.url : "";
    const href = props.card.feed.img_attr ? props.card.feed.img_attr.url : "#";
    const style = {backgroundImage: 'url(' + src + ')', backgroundSize: 'cover', display: 'block', maxHeight: '232px'};
    const opaque = {opacity: 0}
    const heightAuto = {height: 'auto'}
    const positionRelative = {position: 'relative'}
    const categorys = props.card.feed.category;
    const arrayclass = ["evento", "webinar","noticia","empleo"];
    let optionClass ="";
    arrayclass.forEach(function(element) {
        for (let i = 0; i < categorys.length; i++) {
            let categoria = categorys[i].toLowerCase();
            if(categoria ===element){
                optionClass = element.toUpperCase();
                break;
            }                        
        }
        if(optionClass){
            return;
        }        
      });
    let classBack = "";
    switch(optionClass){
        case "EVENTO":
            classBack="background_evento";
        break;
        case "WEBINAR":
            classBack="background_webinar";
        break;
        case "NOTICIA":
            classBack="background_noticias";
        break;
        case "EMPLEO":
            classBack="background_empleo";
        break;
        default:
            classBack="background_none";
            break;
    }
    if (props.layoutType === 'masonry') {
        img =  <a href={props.card.feed.img_attr ? props.card.feed.img_attr.link : "#"}
                  style={style}>
            <img className="feed-img" src={src} alt={alt} style={opaque}/>
        </a>
        innerHeight = {height: 'auto'};
    } else {														
        img =  <a
            href={href}
            className={'fixed-background'}
            style={style}>
        </a>
        innerHeight = {height: '150px'}
    }
    const feedDate = new Date(props.card.feed.pubDate)
    return <div className={`${props.card.class} item`}>
        <style>{props.card.css}</style>
        <div className="feed-box">
            <div style={heightAuto, positionRelative}>
            <div class={`badges_event ${classBack}`}>{optionClass}</div>
                {img}
            </div>
            <div className="item-inner" style={innerHeight}>
                
                <a href={props.card.channelLink} className="channel-title">{props.card.title}</a>
                <span className="pub-date">{feedDate.toLocaleDateString('es-ES', dateOptions)}</span>
                <span className="divider"></span>
                <a href={props.card.feed.link}
                   className="item-title">{props.card.feed.title}</a>
												 
                <div className="extra"></div>
																								 
            </div>
        </div>
    </div>
}

const Layout = (props) => 
    // Masonry layout of cards 
    // column-count : X 
    <div className={`layout + ${props.style}`} style={{"columnCount" : props.columns}}>
        {props.cards.map( (card, index) => 
            <Card key={index} card={card} style={props.style} layoutType={props.layoutType}/>
        )}
    </div>;

class App extends Component {
    constructor() {
        super();
        this.state = {
            layout: "masonry",
            columns: 3,
            maxCards: 15,
            layoutType: "masonry",
			showMoreFeeds: 3							
        };
    }
    componentDidMount() {
        this.fetchEr();

        // cheap responsive approach -- if you want
        window.addEventListener("resize", () => {
            let winWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            if (winWidth > 961) {
                //this.reorder(this.state.cards, 3);
                this.reorder(this.state.totalFeedsCard, 3);
            } else if (winWidth > 576) {
                this.reorder(this.state.totalFeedsCard, 2);
            } else {
                this.reorder(this.state.totalFeedsCard, 1);
            }

        })

    }
    fetchEr = () => {

        fetch(ajaxurl)
            .then(response => response.json())
            .then(result => {
            //console.log(result);
            //this.reorder(result.feeds.slice(0,this.state.maxCards), this.state.columns);
            let winWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            if (winWidth > 961) {
                //this.reorder(this.state.cards, 3);
                this.reorder(result.feeds.slice(0,this.state.maxCards), 3);
            } else if (winWidth > 576) {
                this.reorder(result.feeds.slice(0,this.state.maxCards), 2);
            } else {
                this.reorder(result.feeds.slice(0,this.state.maxCards), 1);
            }
			let feeds= result.feeds.slice(0,this.state.maxCards);				
            this.setState({ 
                totalFeeds: result.feeds,
                globalCss: result.globalCss,
                layoutType: result.layoutType,
                totalFeedsCard: feeds
            });
        })
        .catch(e => e);
    }


    reorder = (arr, columns) => {
        // READ HERE
        // this is the magic
        // re-order the array so the "cards" read left-right
        // cols === CSS column-count value
        // console.log(arr)
        // console.log(columns)
        const cols = columns;
        const out = [];
        const newArray = [];
        let destacados = [];
        let col = 0;
        while(col < cols) {
            for(let i = 0; i < arr.length; i += cols) {
                let _val = arr[i + col];
                let newItem= arr[i + col];           
                if (_val !== undefined) {                  
                    out.push(_val);
                    newItem.feed.newDate = new Date(newItem.feed.pubDate);                    
                    if(!_val.feed.category.includes("Destacado")){
                        newArray.push(newItem);
                    }else{
                        destacados.push(newItem);
                    }
                }
            }
            col++;
        }
        const orderArray = newArray.sort((a, b) => b.feed.newDate - a.feed.newDate);
        destacados=destacados.concat(orderArray);
        let orders=[];

        if(columns >=2){
            const firstOrder =0;
            let firstColumn = this.orderItems(firstOrder, destacados, destacados.length, cols);
            orders = orders.concat(firstColumn);
            const secondOrder =1;
            let secondColumn = this.orderItems(secondOrder, destacados, destacados.length, cols);
            orders = orders.concat(secondColumn);
            if(columns == 3){
                const threeOrder =2;
                let threeColumn = this.orderItems(threeOrder, destacados, destacados.length, cols);
                orders = orders.concat(threeColumn); 
            }
        }else{
            orders = destacados;
        }
        
        this.setState({ cards: orders, columns: columns });		
        // yes, I know Nick... you had another slicker ES6-y implementation
        // but this one I could understand :)
    }
	orderItems = (index, array, max, columns) =>{
        let newItems = [];
        while (index < max) {
            newItems.push(array[index]);
            index +=columns
        }
        return newItems;
    }
	loadMoreFeeds = () =>{
        let {maxCards, showMoreFeeds} = this.state;
        let newMaxCards = maxCards + showMoreFeeds;
        let newShowCards = this.state.totalFeeds.slice(0,newMaxCards);
        this.reorder(newShowCards, this.state.columns);
        this.setState({ maxCards: newMaxCards });
    }


    render() {
        let CARDS = this.state.cards;
        let showMoreButton = null;
        
        if(this.state.totalFeeds !== undefined && this.state.cards !== undefined){
            showMoreButton = this.state.totalFeeds.length - this.state.cards.length < this.state.showMoreFeeds ? null : <div className="load-more-container" ><button onClick={this.loadMoreFeeds} >Cargar Más</button></div>;
        }
		
        return (
            <div>
                <style>{this.state.globalCss}</style>
                <div className="layout--wrapper">
                    { CARDS && <Layout style={this.state.layout} layoutType={this.state.layoutType} columns={this.state.columns} cards={CARDS} /> }
                </div>
				{showMoreButton}								
            </div>
        );
    }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js